export class Gesture {
    constructor(type, enabled) {
        this.type = type;
        this.enabled = enabled;
    }
}
